<div class="overlay d-flex justify-content-center align-items-center" style="z-index: 99999999;">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-dark" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>